import { Component, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}
interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: { componentStack?: string }): void {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  render(): ReactNode {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center px-6 bg-bg">
          <div className="card max-w-md w-full p-6">
            <h1 className="text-lg font-semibold text-text">Something went wrong</h1>
            <p className="mt-2 text-sm text-text-muted">{this.state.error.message}</p>
            <button
              type="button"
              onClick={() => window.location.assign("/")}
              className="mt-4 inline-flex h-11 items-center justify-center rounded-lg bg-accent px-4 text-sm font-medium text-white hover:opacity-90"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
